const ACTION_MOUNT = 0;
const ACTION_INSERT_CHILD = 1;
const ACTION_REMOVE_CHILD = 2;
const ACTION_UPDATE_TEXT = 3;
const ACTION_UPDATE_PROPS = 4;
const KIND_ROOT = 0;
const KIND_COMPONENT = 1;
const KIND_TEXT = 2;
const KIND_FRAGMENT = 3;

export { ACTION_INSERT_CHILD, ACTION_MOUNT, ACTION_REMOVE_CHILD, ACTION_UPDATE_PROPS, ACTION_UPDATE_TEXT, KIND_COMPONENT, KIND_FRAGMENT, KIND_ROOT, KIND_TEXT };
